<template>
  <div>
    <v-toolbar
      tabs
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
        marginBottom: '20px',
        paddingBottom: '20px',
      }"
      height="80"
      card
      color="#fff"
    >
      <v-layout row align-center justify-space-between>
        <v-flex grow>
          <div
            class="mr-3"
            :style="{
              padding: '8px',
              display: 'inline-block',
              backgroundColor: '#ef565c',
              borderRadius: '0.5rem',
            }"
          >
            <v-icon color="#fff" medium>groups</v-icon>
          </div>
          <h1 style="display: inline">
            {{ $t('reports.check_in_and_check_out_report_title') }}
          </h1>
        </v-flex>
        <router-link :to="{ name: 'Reports' }" style="text-decoration: none">
          <v-icon>close</v-icon>
        </router-link>
      </v-layout>

      <v-speed-dial
        key="1"
        v-model="buttonFab.fab"
        absolute
        bottom
        left
        direction="bottom"
        open-on-hover
        transition="scale-transition"
        style="bottom: 0"
      >
        <template v-slot:activator>
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn
                v-model="buttonFab.fab"
                style="z-index: 99"
                color="gradiente"
                dark
                fab
                :small="$vuetify.breakpoint.xsOnly"
                v-on="on"
              >
                <v-icon>more_horiz</v-icon>
                <v-icon>more_horiz</v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t('reports.shared.more_options') }}
            </span>
          </v-tooltip>
        </template>
        <v-tooltip right>
          <v-btn
            fab
            dark
            small
            color="gradiente"
            slot="activator"
            @click="downloadReportAllPDF"
          >
            <v-icon>file_download</v-icon>
          </v-btn>
          <span>{{ $t('reports.shared.download_pdf') }}</span>
        </v-tooltip>
        <v-tooltip right>
          <v-btn
            fab
            dark
            small
            color="gradiente"
            slot="activator"
            @click="downloadReportAllEX"
          >
            <JsonCSV
              class="btn btn-default"
              name="ReporteDeTemperaturaEstudiantes.csv"
              :data="json_data"
              :labels="labels"
              :fields="fields"
            >
              <v-img
                height="25px"
                width="25px"
                :src="require('@/assets/reports/IconoCSV.png')"
              >
              </v-img>
            </JsonCSV>
          </v-btn>
          <span>
            {{ $t('reports.shared.download_xlsx') }}
          </span>
        </v-tooltip>
        <v-tooltip right>
          <v-btn
            fab
            dark
            small
            color="gradiente"
            slot="activator"
            @click="downloadXlsModal"
          >
            <v-icon>sim_card_download</v-icon>
          </v-btn>
          <span>Exportar XLSX por fechas</span>
        </v-tooltip>
        <v-tooltip right>
          <v-btn
            fab
            dark
            small
            color="gradiente"
            slot="activator"
            @click="showSettingModal"
          >
            <v-icon>settings</v-icon>
          </v-btn>
          <span>Ajuste de reportes</span>
        </v-tooltip>
      </v-speed-dial>
      <!-- </template> -->
    </v-toolbar>
    <v-container
      fluid
      grid-list-xl
      style="
        padding: 20px;
        height: 90vh;
        overflow: scroll;
        padding-bottom: 140px !important;
      "
    >
      <v-layout row wrap>
        <!-- new toolbar -->
        <v-flex xs12 style="padding: 0 12px 10px">
          <v-card flat class="border-container">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm4 md3>
                  <v-menu
                    :close-on-content-click="false"
                    :nudge-left="500"
                    :nudge-width="500"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    max-width="600px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :label="$t('reports.shared.search')"
                        class="border-container"
                        prepend-inner-icon="search"
                        clearable
                        solo
                        flat
                        hide-details
                        v-model="search"
                        @click:append-outer="filterSearch(false)"
                        @click:clear="filterSearch(true)"
                        @keyup.enter="filterSearch(false)"
                      >
                        <template v-slot:append>
                          <v-icon v-on="on">tune</v-icon>
                        </template>
                      </v-text-field>
                      <v-btn
                        class="mx-0 my-1"
                        color="grey"
                        dark
                        @click="graph = true"
                        style="width: 100%"
                      >
                        <v-icon> insights </v-icon>
                        {{
                          $t('reports.check_in_and_check_out_report.graphics')
                        }}
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-text>
                        <v-layout row wrap>
                          <!-- profile -->
                          <v-flex xs12 sm4 md6 pa-1>
                            <v-layout row>
                              <v-flex pr-1>
                                <div class="icon-select border-container">
                                  <v-icon color="primary" medium>person</v-icon>
                                </div>
                              </v-flex>
                              <v-flex pl-1>
                                <v-select
                                  class="border-container"
                                  flat
                                  solo
                                  hide-details
                                  return-object
                                  clearable
                                  :items="
                                    perfil.map((e) => ({
                                      ...e,
                                      text: this.$t(e.langKey),
                                    }))
                                  "
                                  item-text="text"
                                  v-model="profiles"
                                  :label="
                                    $t(
                                      'reports.check_in_and_check_out_report.profile'
                                    )
                                  "
                                  multiple
                                  @change="getEntries"
                                >
                                  <template
                                    v-slot:selection="{ item, index }"
                                    v-if="profiles.length >= 3"
                                  >
                                    <span
                                      v-if="
                                        index === profiles.length - 1 &&
                                        profiles.length == 3
                                      "
                                      >(
                                      {{
                                        '+' +
                                        profiles.length +
                                        ' filtro' +
                                        (profiles.length > 1 ? 's' : '')
                                      }}
                                      )</span
                                    >
                                    <span
                                      v-if="
                                        index === profiles.length - 1 &&
                                        profiles.length == 4
                                      "
                                    >
                                      {{
                                        $t(
                                          'reports.check_in_and_check_out_report.all'
                                        )
                                      }}
                                    </span>
                                  </template>

                                  <template v-slot:prepend-item>
                                    <v-list-tile
                                      ripple
                                      @mousedown.prevent
                                      @click="toggle"
                                    >
                                      <v-list-tile-action
                                        style="
                                          padding-left: 17px;
                                          padding-right: 28px;
                                        "
                                      >
                                        <v-icon
                                          :color="
                                            profiles.length > 0 ? 'red' : ''
                                          "
                                        >
                                          {{ icon }}
                                        </v-icon>
                                      </v-list-tile-action>
                                      <v-list-tile-content>
                                        <v-list-tile-title
                                          :color="
                                            profiles.length > 0 ? 'red' : ''
                                          "
                                        >
                                          {{
                                            $t(
                                              'reports.check_in_and_check_out_report.all'
                                            )
                                          }}
                                        </v-list-tile-title>
                                      </v-list-tile-content>
                                    </v-list-tile>
                                    <v-divider class="mt-2"></v-divider>
                                  </template>
                                </v-select>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <!-- level -->
                          <v-flex
                            xs12
                            sm4
                            md6
                            pa-1
                            v-show="this.stdFil && this.profiles.length == 1"
                          >
                            <v-layout row>
                              <v-flex pr-1>
                                <div class="icon-select border-container">
                                  <v-icon color="primary" medium>person</v-icon>
                                </div>
                              </v-flex>
                              <v-flex pl-1>
                                <v-select
                                  multiple
                                  class="border-container"
                                  item-text="levelName"
                                  item-id="levelId"
                                  :label="
                                    $t(
                                      'reports.check_in_and_check_out_report.level'
                                    )
                                  "
                                  flat
                                  solo
                                  hide-details
                                  return-object
                                  clearable
                                  v-model="filters.levelIds"
                                  :items="levels"
                                  @change="filterLevel"
                                />
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <!-- group -->
                          <v-flex
                            xs12
                            sm4
                            md6
                            pa-1
                            v-show="this.stdFil && this.profiles.length == 1"
                          >
                            <v-layout row>
                              <v-flex pr-1>
                                <div class="icon-select border-container">
                                  <v-icon color="primary" medium>person</v-icon>
                                </div>
                              </v-flex>
                              <v-flex pl-1>
                                <v-select
                                  multiple
                                  class="border-container"
                                  :label="
                                    $t(
                                      'reports.check_in_and_check_out_report.group'
                                    )
                                  "
                                  flat
                                  solo
                                  hide-details
                                  no-data-text="No hay grupos"
                                  item-text="groupName"
                                  item-key="groupId"
                                  rows="1"
                                  return-object
                                  clearable
                                  auto-grow
                                  v-model="filters.gradeGroupIds"
                                  :items="grades"
                                  @change="$forceUpdate()"
                                >
                                  <template v-slot:label>
                                    <span class="grey--text">Grupo</span>
                                  </template>
                                  <template
                                    v-slot:selection
                                    v-if="
                                      gradeGroup && gradeGroup.name.length > 19
                                    "
                                  >
                                    <span>{{
                                      shortText(gradeGroup.name)
                                    }}</span>
                                  </template>
                                </v-select>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <!-- role -->
                          <v-flex
                            xs12
                            sm5
                            md6
                            pa-1
                            v-show="this.collFil && this.profiles.length == 1"
                          >
                            <v-layout>
                              <v-flex pr-1>
                                <div class="icon-select border-container">
                                  <v-icon color="primary" medium
                                    >schedule</v-icon
                                  >
                                </div>
                              </v-flex>
                              <v-flex pl-1>
                                <v-select
                                  multiple
                                  class="border-container"
                                  solo
                                  flat
                                  hide-details
                                  @input="getEntries"
                                  :items="roles"
                                  v-model="id_web_role"
                                  item-value="id"
                                  item-text="name"
                                  :label="
                                    $t(
                                      'reports.check_in_and_check_out_report.role'
                                    )
                                  "
                                  clearable
                                />
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <!-- empty -->
                          <v-flex xd12 sm12 md12></v-flex>
                          <!-- temperature -->
                          <!-- <v-flex xd12 sm12 md12>
                            <p>
                              {{
                                $t(
                                  'reports.check_in_and_check_out_report.temperature'
                                )
                              }}
                            </p>
                            <v-layout row wrap>
                              <v-flex row xs6 pa-1>
                                <v-text-field
                                  :label="
                                    $t(
                                      'reports.check_in_and_check_out_report.initial'
                                    )
                                  "
                                  clearable
                                  hide-details
                                  v-model="min_temp"
                                  type="number"
                                  :min="30"
                                  :max="49.9"
                                  @change="getEntries"
                                />
                              </v-flex>
                              <v-flex row xs6 pa-1>
                                <v-text-field
                                  :label="
                                    $t(
                                      'reports.check_in_and_check_out_report.final'
                                    )
                                  "
                                  clearable
                                  hide-details
                                  v-model="max_temp"
                                  type="number"
                                  :min="30.1"
                                  :max="50"
                                  @change="getEntries"
                                />
                              </v-flex>
                            </v-layout>
                          </v-flex> -->
                          <!-- initial date -->
                          <v-flex xd12 sm12 md12 pa-1>
                            <div class="border-container px-3">
                              <v-layout row wrap align-center>
                                <v-flex xs5 sm4 pr-0>
                                  {{
                                    $t(
                                      'reports.check_in_and_check_out_report.start_date'
                                    )
                                  }}
                                </v-flex>
                                <v-flex xs7 sm8 pl-0 ml>
                                  <v-menu
                                    :close-on-content-click="true"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                  >
                                    <template late v-slot:activator="{ on }">
                                      <v-text-field
                                        id="first-small"
                                        :value="momentFormatFirst"
                                        :label="
                                          $t(
                                            'reports.check_in_and_check_out_report.start_date'
                                          )
                                        "
                                        prepend-icon="event"
                                        readonly
                                        solo
                                        flat
                                        hide-details
                                        v-on="on"
                                        class="padded"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      header-color="primary"
                                      color="secondary"
                                      locale="es-419"
                                      scrollable
                                      :min="firstDate"
                                      :max="today"
                                      v-model="timeFirst"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-flex>
                          <!-- final date -->
                          <v-flex xd12 sm12 md12 pa-1>
                            <div class="border-container px-3">
                              <v-layout row wrap align-center>
                                <v-flex xs5 sm4 pr-0>
                                  {{
                                    $t(
                                      'reports.check_in_and_check_out_report.end_date'
                                    )
                                  }}
                                </v-flex>
                                <v-flex xs7 sm8 pl-0>
                                  <v-menu
                                    :close-on-content-click="true"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        id="last-small"
                                        :value="momentFormatLast"
                                        :label="
                                          $t(
                                            'reports.check_in_and_check_out_report.end_date'
                                          )
                                        "
                                        prepend-icon="event"
                                        readonly
                                        v-on="on"
                                        solo
                                        flat
                                        hide-details
                                        class="padded"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      header-color="primary"
                                      color="secondary"
                                      locale="es-419"
                                      scrollable
                                      :min="timeFirst"
                                      :max="today"
                                      v-model="timeLast"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-card-actions
                        style="justify-content: end; margin-right: 8px"
                      >
                        <v-flex
                          xd12
                          sm7
                          md4
                          style="display: flex; justify-content: end"
                        >
                          <v-btn
                            @click="filterClear"
                            v-show="showFilter"
                            color="primary"
                          >
                            <v-icon left>close</v-icon>
                            {{ $t('reports.shared.clear_filters') }}
                          </v-btn>
                        </v-flex>
                      </v-card-actions>
                    </v-card>
                  </v-menu>
                </v-flex>
                <v-flex class="box-circle-counter" v-show="stdTrue == true">
                  <RoundCounter
                    title="Total de Ingresos"
                    color="#025a90"
                    :count="stats.totalCount"
                  />
                </v-flex>
                <v-flex class="box-circle-counter" v-show="stdTrue == true">
                  <RoundCounter
                    title="Total de Salidas"
                    color="#b97182"
                    :count="stats.totalWithExitCount"
                  />
                </v-flex>
                <v-flex class="box-circle-counter" v-show="stdTrue == true">
                  <RoundCounter
                    :title="
                      $t('reports.check_in_and_check_out_report.total_students')
                    "
                    color="#f1c40f"
                    :count="stats.studentCount"
                  />
                </v-flex>
                <v-flex class="box-circle-counter" v-show="collTrue == true">
                  <RoundCounter
                    :title="
                      $t(
                        'reports.check_in_and_check_out_report.total_number_of_collaborators'
                      )
                    "
                    color="#225d6b"
                    :count="stats.collaboratorCount"
                  />
                </v-flex>
                <v-flex
                  class="box-circle-counter"
                  v-show="
                    collTrue == true &&
                    profiles.length == 1 &&
                    stats.roleAccessCountList
                  "
                  v-for="colls in stats.roleAccessCountList"
                  :key="colls.label"
                >
                  <RoundCounter
                    :title="colls.label"
                    color="#5fa4b5"
                    :count="colls.count"
                  />
                </v-flex>
                <v-flex class="box-circle-counter" v-show="parTrue == true">
                  <RoundCounter
                    :title="
                      $t(
                        'reports.check_in_and_check_out_report.total_number_of_tutors'
                      )
                    "
                    color="#0b5345"
                    :count="stats.parentCount"
                  />
                </v-flex>
                <v-flex class="box-circle-counter" v-show="visTrue == true">
                  <RoundCounter
                    :title="
                      $t('reports.check_in_and_check_out_report.total_visitors')
                    "
                    color="#87985a"
                    :count="stats.visitCount"
                  />
                </v-flex>
                <v-flex
                  class="box-circle-counter"
                  v-show="stdTrue == true && profiles.length == 1"
                >
                  <RoundCounter
                    title="Hombres"
                    color="#05c4db"
                    :count="stats.maleStudentCount"
                  />
                </v-flex>
                <v-flex
                  class="box-circle-counter"
                  style="text-align: -webkit-center"
                  v-show="stdTrue == true && profiles.length == 1"
                >
                  <RoundCounter
                    title="Mujeres"
                    color="#cb3c88"
                    :count="stats.femaleStudentCount"
                  />
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 style="padding: 0 12px 10px">
          <v-card flat class="border-container">
            <v-card-text class="px-0 py-0">
              <v-data-table
                :rows-per-page-items="[25, 50, 100]"
                :items="entries"
                :loading="working.wEntries"
                :pagination.sync="pagination"
                :total-items="totalitemsback"
                :headers="showHeaders"
                item-key="id"
                no-results-text="No se encontraron coincidencias"
                no-data-text="No hay registros"
                class="entries-table elevation-1"
              >
                <template slot="headerCell" slot-scope="props">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        {{ props.header.text }}
                      </span>
                    </template>
                    <span>
                      {{ props.header.text }}
                    </span>
                  </v-tooltip>
                </template>
                <template v-slot:items="props">
                  <tr
                    v-bind:class="
                      props.item.isNew
                        ? 'new-entry'
                        : props.item.temperature > 37.4
                        ? 'danger'
                        : ''
                    "
                  >
                    <td
                      class="text-xs-left"
                      style="width: 180px; max-width: 180px; min-width: 180px"
                    >
                      {{ props.item.profile }}
                    </td>
                    <td
                      class="text-xs-left"
                      style="width: 200px; max-width: 200px; min-width: 200px"
                    >
                      {{ props.item.firstName }}
                    </td>
                    <td
                      class="text-xs-left"
                      style="width: 200px; max-width: 200px; min-width: 200px"
                    >
                      {{ props.item.lastName }}
                    </td>
                    <td
                      class="text-xs-left"
                      style="width: 180px; max-width: 180px; min-width: 180px"
                    >
                      {{
                        props.item.inAt === props.item.outAt
                          ? noRecord
                          : `${epochTimeParseToUiDate(props.item.inAt)} - ${
                              props.item.assistance
                            }`
                      }}
                    </td>
                    <td
                      class="text-xs-left"
                      style="width: 180px; max-width: 180px; min-width: 180px"
                    >
                      {{
                        props.item.inAt === props.item.outAt
                          ? noRecord
                          : epochTimeParseToUiTime(props.item.inAt)
                      }}
                    </td>
                    <td
                      class="text-xs-left"
                      style="width: 180px; max-width: 180px; min-width: 180px"
                    >
                      {{ epochTimeParseToUiDate(props.item.outAt) }}
                    </td>
                    <td
                      class="text-xs-left"
                      style="width: 180px; max-width: 180px; min-width: 180px"
                    >
                      {{ epochTimeParseToUiTime(props.item.outAt) }}
                    </td>
                    <td
                      class="text-xs-left"
                      style="width: 200px; max-width: 200px; min-width: 200px"
                    >
                      {{ props.item.personId || '----' }}
                    </td>
                    <td
                      class="text-xs-left"
                      style="width: 200px; max-width: 200px; min-width: 200px"
                    >
                      {{ props.item.level || '----' }}
                    </td>
                    <td
                      class="text-xs-left"
                      style="width: 200px; max-width: 200px; min-width: 200px"
                    >
                      {{ props.item.grade || '----' }}
                    </td>
                    <td
                      class="text-xs-left"
                      style="width: 180px; max-width: 180px; min-width: 180px"
                    >
                      <v-btn
                        v-if="props.item.photoUrl"
                        icon
                        :style="{ margin: 0 }"
                      >
                        <v-avatar
                          @click="openPhotoModal(props.item)"
                          :tile="tile"
                          size="30px"
                          color="grey lighten-4"
                        >
                          <img :src="props.item.photoUrl" alt="avatar" />
                        </v-avatar>
                      </v-btn>
                      <v-icon size="35px" v-else>account_circle</v-icon>
                    </td>
                    <!-- <td
                      class="text-xs-left"
                      style="width: 200px; max-width: 200px; min-width: 200px"
                    >
                      {{ props.item.temperature | temperature }}
                    </td> -->
                    <td
                      class="text-xs-left"
                      style="width: 200px; max-width: 200px; min-width: 200px"
                    >
                      {{ genderFix(props.item.gender) || '----' }}
                    </td>
                    <td
                      class="text-xs-left"
                      style="width: 160px; max-width: 160px; min-width: 160px"
                    >
                      {{ props.item.role || '----' }}
                    </td>
                    <td
                      class="text-xs-left"
                      style="width: 160px; max-width: 160px; min-width: 160px"
                    >
                      {{ props.item.hosts || '----' }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <ReportSettings
        :show="showSetting"
        title="Configuración de reporte de entradas y salidas"
        reportSettingtype="ENTRY_DEPARTURE"
        @closeEditSetting="onCloseEditSetting"
      />
      <loading v-model="working.wLoading" text="Descargando..." />
      <success v-model="toast.success" text="Operación exitosa" />
      <error v-model="toast.failed" text="Ups ocurrió un error" />
      <graph
        v-model="graph"
        @onClosed="onCancel"
        :value="graph"
        :stats="statsCount"
        :filters="graphFils"
      />
      <ImageModal
        title="Foto del visitante"
        :img-src="imgSrc"
        :is-open="modalImage"
        @onClose="modalImage = !modalImage"
      />

      <DowloadXlsModal
        :isOpen="modalXls"
        :startDate="today"
        @onClose="modalXls = !modalXls"
        @onGetReport="downloadXlsReport"
        ref="dowloadXlsModal"
      />
      <alert
        v-model="toast.alert"
        :title="toast.title"
        :description="toast.description"
      ></alert>
    </v-container>
  </div>
</template>

<script>
import moment from 'moment'
import 'moment-timezone'
import JsonCSV from 'vue-json-csv'
import { mapGetters } from 'vuex'
import { _isSomeDifferent } from '../../../utils/genericUtils.js'
import alert from '../../Dialogs/Alert'
import error from '../../Dialogs/Error'
import loading from '../../Dialogs/Loading'
import success from '../../Dialogs/Success'
import DowloadXlsModal from '../../Modals/DownloadXlsModal.vue'
import graph from '../../Modals/Graphs.vue'
import ImageModal from '../../Modals/ImageModal.vue'
import ReportSettings from '../../Modals/reportSettings.vue'
import RoundCounter from '../../Tools/roundCounter.vue'
import { filterByLevel, isNotEmpty, parseGroups, parseLevels } from './utils.js'

export default {
  components: {
    loading,
    success,
    error,
    alert,
    JsonCSV,
    graph,
    ImageModal,
    DowloadXlsModal,
    RoundCounter,
    ReportSettings,
  },
  data: () => ({
    posibleFilters: { gradeGroups: [], levels: [] },
    filters: {
      gradeGroupIds: '',
      levelIds: '',
    },
    noRecord: 'Sin registro',
    showFilter: false,
    initialStateParams: [],
    modalImage: false,
    modalXls: false,
    imgSrc: '',
    size: '',
    offset: '',
    from: '',
    to: '',
    from1: '',
    to1: '',
    startDate: null,
    endDate: null,
    search: '',
    id_level: '',
    id_grade_group: '',
    id_web_role: '',
    min_temp: '',
    max_temp: '',
    temperatures: [],
    profiles: [],
    order_field: '',
    order_direction: '',
    temperature: [],
    filterby: '',

    stdTrue: true,
    collTrue: true,
    parTrue: true,
    visTrue: true,
    stdFil: false,
    collFil: false,
    pagination: {
      sortBy: 'inAt',
    },
    buttonFab: {
      fab: false,
      hidden: false,
    },
    modalF: false,
    modalL: false,
    graph: false,
    statsCount: '',
    stats: '',
    timeFirst: moment().format('YYYY-MM-DD'),
    timeLast: moment().format('YYYY-MM-DD'),
    today: moment().format('YYYY-MM-DD'),
    firstDate: new Date(
      new Date().setDate(new Date().getDate() - 30)
    ).toLocaleDateString('sv-SE'),
    entries: [],
    temperaturas: [],
    grades: [],
    levels: [],
    json_data: [],
    roles: [],
    perfil: [
      {
        text: 'Alumno',
        value: 'STUDENT',
        langKey: 'reports.check_in_and_check_out_report.students',
      },
      {
        text: 'Colaborador',
        value: 'COLLABORATOR',
        langKey: 'reports.check_in_and_check_out_report.collaborators',
      },
      {
        text: 'Tutores',
        value: 'PARENT',
        langKey: 'reports.check_in_and_check_out_report.tutors',
      },
      {
        text: 'Visitante',
        value: 'VISIT',
        langKey: 'reports.check_in_and_check_out_report.visitors',
      },
    ],
    perfilAll: [
      {
        text: 'Alumno',
        value: 'STUDENT',
        langKey: 'reports.check_in_and_check_out_report.students',
      },
      {
        text: 'Colaborador',
        value: 'COLLABORATOR',
        langKey: 'reports.check_in_and_check_out_report.collaborators',
      },
      {
        text: 'Tutores',
        value: 'PARENT',
        langKey: 'reports.check_in_and_check_out_report.tutors',
      },
      {
        text: 'Visitante',
        value: 'VISIT',
        langKey: 'reports.check_in_and_check_out_report.visitors',
      },
    ],
    labels: {
      level: 'Nivel',
      grade: 'Grupo',
      firstName: 'Nombre',
      lastName: 'Apellido',
      personId: 'Matrícula',
      createdAt: 'Fecha/Hora',
      // temperature: 'Temperatura',
    },
    fields: [
      'level',
      'grade',
      'firstName',
      'lastName',
      'personId',
      'createdAt',
      'temperature',
    ],
    headersAll: [
      {
        text: 'Perfil',
        align: 'left',
        value: 'profile',
        sortable: true,
        width: '180px',
        langKey: 'reports.check_in_and_check_out_report.profile',
      },
      {
        text: 'Nombre',
        align: 'left',
        value: 'firstName',
        sortable: true,
        width: '200px',
        langKey: 'reports.check_in_and_check_out_report.first_name',
      },
      {
        text: 'Apellido',
        align: 'left',
        value: 'lastName',
        sortable: true,
        width: '200px',
        langKey: 'reports.check_in_and_check_out_report.last_name',
      },
      {
        text: 'Fecha Entrada',
        align: 'left',
        value: 'inAt',
        sortable: true,
        width: '180px',
        langKey: 'reports.check_in_and_check_out_report.entry_date',
      },
      {
        text: 'Hora Entrada',
        align: 'left',
        value: 'inAt',
        sortable: true,
        width: '180px',
        langKey: 'reports.check_in_and_check_out_report.entry_time',
      },
      {
        text: 'Fecha Salida',
        align: 'left',
        value: 'outAt',
        sortable: false,
        width: '180px',
        langKey: 'reports.check_in_and_check_out_report.out_date',
      },
      {
        text: 'Hora Salida',
        align: 'left',
        value: 'outAt',
        sortable: false,
        width: '180px',
        langKey: 'reports.check_in_and_check_out_report.out_time',
      },
      {
        text: 'Matrícula',
        align: 'left',
        value: 'personId',
        width: '200px',
        langKey: 'reports.check_in_and_check_out_report.enrollment',
      },
      {
        text: 'Nivel',
        align: 'left',
        value: 'level',
        width: '200px',
        langKey: 'reports.check_in_and_check_out_report.level',
      },
      {
        text: 'Grado',
        align: 'left',
        value: 'grade',
        width: '200px',
        langKey: 'reports.check_in_and_check_out_report.grade',
      },
      // {
      //   text: 'Temperatura',
      //   align: 'left',
      //   value: 'temperature',
      //   sortable: true,
      //   width: '200px',
      //   langKey: 'reports.check_in_and_check_out_report.temperature',
      // },
      {
        text: 'Género',
        align: 'left',
        value: 'gender',
        width: '200px',
        langKey: 'reports.check_in_and_check_out_report.gender',
      },
      {
        text: 'Rol',
        align: 'left',
        value: 'role',
        width: '160px',
        langKey: 'reports.check_in_and_check_out_report.role',
      },
      {
        text: 'Visitó a',
        align: 'left',
        value: 'collaborator',
        width: '160px',
        langKey: 'reports.check_in_and_check_out_report.visited',
      },
    ],
    headersF: [
      {
        text: 'Fecha Entrada',
        align: 'left',
        value: 'inAt',
        sortable: true,
        width: '180px',
      },
      {
        text: 'Hora Entrada',
        align: 'left',
        value: 'inAt',
        sortable: true,
        width: '180px',
      },
      {
        text: 'Fecha Salida',
        align: 'left',
        value: 'outAt',
        sortable: false,
        width: '180px',
      },
      {
        text: 'Hora Salida',
        align: 'left',
        value: 'outAt',
        sortable: false,
        width: '180px',
      },
      {
        text: 'Perfil',
        align: 'left',
        value: 'profile',
        sortable: true,
        width: '180px',
      },
      {
        text: 'Nombre',
        align: 'left',
        value: 'firstName',
        sortable: true,
        width: '200px',
      },
      {
        text: 'Apellido',
        align: 'left',
        value: 'lastName',
        sortable: true,
        width: '200px',
      },
      // {
      //   text: 'Temperatura',
      //   align: 'left',
      //   value: 'temperature',
      //   sortable: true,
      //   width: '200px',
      // },
      {
        text: 'Matrícula',
        align: ' d-none',
        value: 'personId',
        width: '200px',
      },
      { text: 'Género', align: ' d-none', value: 'gender', width: '200px' },
      { text: 'Nivel', align: ' d-none', value: 'level', width: '200px' },
      { text: 'Grado', align: ' d-none', value: 'grade', width: '200px' },
      { text: 'Rol', align: ' d-none', value: 'role', width: '160px' },
      {
        text: 'Visitó a',
        align: ' d-none',
        value: 'collaborator',
        width: '160px',
      },
    ],
    selectedHeaders: [],
    gradeGroup: '',
    level: '',
    toast: {
      success: false,
      failed: false,
      alert: false,
      title: null,
      description: null,
    },
    working: {
      wEntries: false,
      wLoading: false,
    },
    connected: false,
    totalitemsback: 0,
    showFilters: false,
    graphFils: {},
    showSetting: false,
  }),
  filters: {
    temperature: function (value) {
      if (isNaN(value)) {
        return 'N/A'
      }
      return value.toFixed(1) + ' ºC'
    },
  },
  methods: {
    setLang() {
      for (let i = 0; i < this.headers.length; i++) {
        const el = this.headers[i]
        el.text = this.$t(el.langKey)
      }
      this.selectedHeaders = this.headers
    },
    onCloseEditSetting() {
      this.showSetting = false
    },
    showSettingModal() {
      this.showSetting = true
    },
    epochTimeParseToUiDate(value = null) {
      if (value === null) return this.noRecord
      return moment(new Date(value)).format('DD/MM/YYYY')
      // .tz(this.getBrandTZ.timezone)
    },
    epochTimeParseToUiTime(value = null) {
      if (value === null) return this.noRecord
      return moment(new Date(value)).format('HH:mm:ss')
      // .tz(this.getBrandTZ.timezone)
    },
    openPhotoModal(item) {
      this.imgSrc = item.photoUrl
      this.modalImage = true
    },
    onCancel() {
      this.graph = false
      this.$forceUpdate()
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllFruit) {
          this.profiles = []
        } else {
          this.profiles = this.perfilAll.slice()
        }
      })
    },
    genderFix(value) {
      switch (value) {
        case null:
          return '----'
        case 'MALE':
          return 'Masculino'
        case 'FEMALE':
          return 'Femenino'
        default:
          break
      }
    },
    shortText(text) {
      var cadena = text.slice(0, 19)
      return cadena + '...'
    },
    filterSearch(clean) {
      this.showFilters = false
      if (clean) {
        this.search = ''
      } else {
        this.search = this.search ? this.search : ''
      }

      if (!this.working.wLoading) {
        this.getEntries()
      }
    },

    getEntries() {
      var self = this
      this.callApi(function (items) {
        self.entries = items
      })
    },
    getGraphValors(params) {
      /* this.graphFils = {}
      this.stats = ''
      var params = {}
      params.from = this.timeFirst
      params.to = this.timeLast

      if (this.level)
        params.id_level = this.level.id;
      if (this.gradeGroup)
        params.id_grade_group = this.gradeGroup.id;
      if (this.id_web_role)
        params.id_web_role = this.id_web_role;
      if (this.search)
        params.search = this.search;

      params.profiles = []
      for (let a = 0; a < this.profiles.length; a++) {
        params.profiles.push(this.profiles[a].value)
      } */

      this.graphFils = params
      this.$store
        .dispatch('reports/getGraphValors', params)
        .then((response) => {
          this.stats = response.data
          this.statsCount = response.data
          // this.$forceUpdate()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    callApi(callback, ignorePagination, isInitialStateParams = false) {
      this.working.wEntries = true
      var offset = (this.pagination.page - 1) * this.pagination.rowsPerPage
      const params = {}
      var paramss = {}
      this.stdFil = false
      this.collFil = false

      if (!ignorePagination) {
        params.size = this.pagination.rowsPerPage
        params.offset = offset
      }

      if (this.timeFirst) {
        params.from = this.timeFirst
      }
      if (this.timeLast) {
        params.to = this.timeLast
      }
      if (this.level) {
        params.id_level = this.level.id
      }
      if (this.gradeGroup) {
        params.id_grade_group = this.gradeGroup.id
      }
      if (this.search) {
        params.search = this.search
      }
      if (isNotEmpty(this.filters.levelIds)) {
        params.levelIds = this.filters.levelIds.map((e) => e.levelId)
      }
      if (isNotEmpty(this.filters.gradeGroupIds)) {
        params.gradeGroupIds = this.filters.gradeGroupIds.map((e) => e.groupId)
      }

      if (this.profiles) {
        params.profiles = []
        var array = [
          {
            text: 'Perfil',
            align: 'left',
            value: 'profile',
            sortable: true,
            width: '180px',
            langKey: 'reports.check_in_and_check_out_report.profile',
          },
          {
            text: 'Nombre',
            align: 'left',
            value: 'firstName',
            sortable: true,
            width: '200px',
            langKey: 'reports.check_in_and_check_out_report.first_name',
          },
          {
            text: 'Apellido',
            align: 'left',
            value: 'lastName',
            sortable: true,
            width: '200px',
            langKey: 'reports.check_in_and_check_out_report.last_name',
          },
          {
            text: 'Fecha Entrada',
            align: 'left',
            value: 'inAt',
            sortable: true,
            width: '180px',
            langKey: 'reports.check_in_and_check_out_report.entry_date',
          },
          {
            text: 'Hora Entrada',
            align: 'left',
            value: 'inAt',
            sortable: true,
            width: '180px',
            langKey: 'reports.check_in_and_check_out_report.entry_time',
          },
          {
            text: 'Fecha Salida',
            align: 'left',
            value: 'outAt',
            sortable: false,
            width: '180px',
            langKey: 'reports.check_in_and_check_out_report.out_date',
          },
          {
            text: 'Hora Salida',
            align: 'left',
            value: 'outAt',
            sortable: false,
            width: '180px',
            langKey: 'reports.check_in_and_check_out_report.out_time',
          },
          {
            text: 'Matrícula',
            align: 'd-none',
            value: 'personId',
            width: '200px',
            langKey: 'reports.check_in_and_check_out_report.enrollment',
          },
          {
            text: 'Nivel',
            align: 'left',
            value: 'level',
            width: '200px',
            langKey: 'reports.check_in_and_check_out_report.level',
          },
          {
            text: 'Grado',
            align: 'left',
            value: 'grade',
            width: '200px',
            langKey: 'reports.check_in_and_check_out_report.grade',
          },
          {
            text: 'Foto',
            align: 'left',
            value: 'photo',
            width: '180px',
            sortable: false,
            langKey: 'reports.check_in_and_check_out_report.photo',
          },
          // {
          //   text: 'Temperatura',
          //   align: 'left',
          //   value: 'temperature',
          //   sortable: true,
          //   width: '200px',
          //   langKey: 'reports.check_in_and_check_out_report.temperature',
          // },
          {
            text: 'Género',
            align: 'd-none',
            value: 'gender',
            width: '200px',
            langKey: 'reports.check_in_and_check_out_report.gender',
          },
          {
            text: 'Rol',
            align: 'd-none',
            value: 'role',
            width: '160px',
            langKey: 'reports.check_in_and_check_out_report.role',
          },
          {
            text: 'Visitó a',
            align: 'd-none',
            value: 'collaborator',
            width: '160px',
            langKey: 'reports.check_in_and_check_out_report.visited',
          },
        ]

        this.stdTrue = false
        this.collTrue = false
        this.parTrue = false
        this.visTrue = false

        for (let a = 0; a < this.profiles.length; a++) {
          if (this.profiles[a].value == '' || this.profiles.length == 5) {
            this.profiles = this.perfilAll
            this.headers = Object.values(this.headersAll)
            this.selectedHeaders = this.headers
            this.id_web_role = ''
            this.level = ''
            this.gradeGroup = ''
            this.stdTrue = true
            this.collTrue = true
            this.parTrue = true
            this.visTrue = true
          }
          if (this.profiles[a].value == 'STUDENT') {
            params.profiles.push(this.profiles[a].value)
            this.stdTrue = true
            this.id_web_role = ''
            this.stdFil = true

            for (let a = 0; a < array.length; a++) {
              if (array[a].text == 'Matrícula') {
                array[a].align = 'left'
              }
              if (array[a].text == 'Género') {
                array[a].align = 'left'
              }
              if (array[a].text == 'Nivel') {
                array[a].align = 'left'
              }
              if (array[a].text == 'Grado') {
                array[a].align = 'left'
              }
            }
          }
          if (this.profiles[a].value == 'COLLABORATOR') {
            params.profiles.push(this.profiles[a].value)
            this.collTrue = true
            this.level = ''
            this.gradeGroup = ''
            this.collFil = true

            for (let a = 0; a < array.length; a++) {
              if (array[a].text == 'Rol') {
                array[a].align = 'left'
              }
            }

            if (this.profiles.length == 1) {
              paramss.size = this.pagination.rowsPerPage
              paramss.offset = offset
              paramss.from = this.timeLast
              paramss.to = this.timeLast

              this.$store
                .dispatch('reports/getCollaboratorEntriesReport', paramss)
                .then((response) => {
                  this.roles = response.data.roles
                })
                .catch((error) => {
                  console.log(error)
                })
            }
          }
          if (this.profiles[a].value == 'PARENT') {
            params.profiles.push(this.profiles[a].value)
            this.parTrue = true
            this.level = ''
            this.gradeGroup = ''
            this.id_web_role = ''
          }
          if (this.profiles[a].value == 'VISIT') {
            params.profiles.push(this.profiles[a].value)
            this.visTrue = true
            this.level = ''
            this.gradeGroup = ''
            this.id_web_role = ''
            for (let a = 0; a < array.length; a++) {
              if (array[a].text == 'Visitó a') {
                array[a].align = 'left'
              }
            }
          }
        }
        if (this.profiles.length == 0) {
          this.profiles = this.perfilAll
          this.headers = Object.values(this.headersAll)
          // this.selectedHeaders = this.headers
          this.setLang()
          this.id_web_role = ''
          this.level = ''
          this.gradeGroup = ''
          this.stdTrue = true
          this.collTrue = true
          this.parTrue = true
          this.visTrue = true
        } else {
          this.headers = Object.values(array)
          // this.selectedHeaders = this.headers
          this.setLang()
        }
      }
      if (this.id_web_role) {
        params.roleIds = this.id_web_role
      }
      if (this.min_temp) {
        params.min_temp = this.min_temp
      }
      if (this.max_temp) {
        params.max_temp = this.max_temp
      }

      if (this.pagination.sortBy) {
        params.order_field = this.pagination.sortBy

        if (this.pagination.descending == true) {
          params.order_direction = 'asc'
        } else {
          params.order_direction = 'desc'
        }
      }

      if (isInitialStateParams === true) {
        const tempProfiles = structuredClone(this.perfil).map((e) => e.value)
        const tempObj = structuredClone({
          ...params,
          profiles: '',
        })
        const tempParams = Object.keys(tempObj).map((e) => `${e}_${tempObj[e]}`)
        return tempParams.concat(tempProfiles)
      }

      const tempProfiles = params.profiles.map((e) => e)
      const tempObj = structuredClone({
        ...params,
        profiles: '',
      })
      const tempParams = Object.keys(params).map((e) => `${e}_${tempObj[e]}`)

      this.showFilter = _isSomeDifferent(
        structuredClone(this.initialStateParams),
        tempParams.concat(tempProfiles)
      )

      const graphsPromise = this.getGraphValors(params)
      const entriesPromise = this.$store
        .dispatch('reports/getStudentEntriesReportAll', params)
        .then((response) => {
          this.working.wEntries = false
          this.totalitemsback = response.data.total
          callback(response.data.items)
          // this.$forceUpdate()
        })
        .catch((error) => {
          this.working.wEntries = false
          console.log(error)
        })

      //Update view till both request have been solved
      Promise.all([graphsPromise, entriesPromise]).then(() =>
        this.$forceUpdate()
      )
    },
    downloadReportAllPDF() {
      var params = {}

      if (this.profiles == null) {
        this.profiles = ''
        this.level = ''
        this.gradeGroup = ''
        this.id_web_role = ''
      }

      if (this.profiles.value == 'STUDENT') {
        this.id_web_role = ''
      }
      if (this.profiles.value == 'COLLABORATOR') {
        this.level = ''
        this.gradeGroup = ''
      }
      if (this.profiles.value == 'PARENT') {
        this.level = ''
        this.gradeGroup = ''
        this.id_web_role = ''
      }
      if (this.profiles.value == 'VISIT') {
        this.level = ''
        this.gradeGroup = ''
        this.id_web_role = ''
      }

      if (this.timeFirst) {
        params.from = this.timeFirst
      }
      if (this.timeLast) {
        params.to = this.timeLast
      }
      if (this.level) {
        params.id_level = this.level.id
      }
      if (this.gradeGroup) {
        params.id_grade_group = this.gradeGroup.id
      }
      if (this.search) {
        params.search = this.search
      }
      if (this.profiles) {
        params.profiles = []
        for (let a = 0; a < this.profiles.length; a++) {
          params.profiles.push(this.profiles[a].value)
        }
      }
      if (this.id_web_role) {
        params.id_web_role = this.id_web_role
      }
      if (this.min_temp) {
        params.min_temp = this.min_temp
      }
      if (this.max_temp) {
        params.max_temp = this.max_temp
      }
      if (this.min_temp) {
        params.min_temp = this.min_temp
      }
      if (this.max_temp) {
        params.max_temp = this.max_temp
      }

      if (this.pagination.sortBy) {
        params.order_field = this.pagination.sortBy

        if (this.pagination.descending == true) {
          params.order_direction = 'asc'
        } else {
          params.order_direction = 'desc'
        }
      }

      this.$store
        .dispatch('reports/getAllReportAllIngresoPDF', params)
        .then((response) => {
          var url = window.URL.createObjectURL(response.data)
          var a = document.createElement('a')
          a.href = url
          a.download = 'reporte-ingresos.pdf'
          a.click()
          a.remove()
          setTimeout(() => window.URL.revokeObjectURL(url), 100)
          this.working.wLoading = false
          this.toast.success = true
        })
        .catch((error) => {
          this.toast.failed = true
          console.log(error)
        })
    },
    downloadReportAllEX() {
      var params = {}

      if (this.profiles == null) {
        this.profiles = ''
        this.level = ''
        this.gradeGroup = ''
        this.id_web_role = ''
      }

      if (this.profiles.value == 'STUDENT') {
        this.id_web_role = ''
      }
      if (this.profiles.value == 'COLLABORATOR') {
        this.level = ''
        this.gradeGroup = ''
      }
      if (this.profiles.value == 'PARENT') {
        this.level = ''
        this.gradeGroup = ''
        this.id_web_role = ''
      }
      if (this.profiles.value == 'VISIT') {
        this.level = ''
        this.gradeGroup = ''
        this.id_web_role = ''
      }

      if (this.startDate && this.endDate) {
        console.log('Downloading extended report')
        params.from = this.startDate
        params.to = this.endDate
      } else {
        if (this.timeFirst) {
          params.from = this.timeFirst
        }
        if (this.timeLast) {
          params.to = this.timeLast
        }
      }

      if (this.level) {
        params.id_level = this.level.id
      }
      if (this.gradeGroup) {
        params.id_grade_group = this.gradeGroup.id
      }
      if (this.search) {
        params.search = this.search
      }
      if (this.profiles) {
        params.profiles = []
        for (let a = 0; a < this.profiles.length; a++) {
          params.profiles.push(this.profiles[a].value)
        }
      }
      if (this.id_web_role) {
        params.id_web_role = this.id_web_role
      }
      if (this.min_temp) {
        params.min_temp = this.min_temp
      }
      if (this.max_temp) {
        params.max_temp = this.max_temp
      }
      if (this.min_temp) {
        params.min_temp = this.min_temp
      }
      if (this.max_temp) {
        params.max_temp = this.max_temp
      }

      if (this.pagination.sortBy) {
        params.order_field = this.pagination.sortBy

        if (this.pagination.descending == true) {
          params.order_direction = 'asc'
        } else {
          params.order_direction = 'desc'
        }
      }

      this.working.wLoading = true
      this.$store
        .dispatch('reports/getAllReportAllIngresoEX', params)
        .then((response) => {
          var url = window.URL.createObjectURL(response.data)
          var a = document.createElement('a')
          a.href = url
          a.download = 'reporte-ingresos.xlsx'
          a.click()
          a.remove()
          setTimeout(() => window.URL.revokeObjectURL(url), 100)
          this.working.wLoading = false
          this.toast.success = true
        })
        .catch((error) => {
          this.working.wLoading = false
          console.log(error)
          if (error.response && error.response.status == 409) {
            this.toast.title = '¡Atención!'
            this.toast.description =
              'Actualmente otro usuario de tu colegio está realizando la descarga del reporte, por favor espera a que el proceso termine para poder continuar.'
            this.toast.alert = true
          } else {
            this.toast.failed = true
          }
        })
        .finally(() => {
          this.startDate = null
          this.endDate = null
          this.modalXls = false
          this.$refs.dowloadXlsModal.onClose()
        })
    },
    downloadXlsModal() {
      this.$refs.dowloadXlsModal.onOpen()
      this.modalXls = true
    },
    downloadXlsReport(e) {
      console.log(e.startDate + ' - ' + e.endDate)
      this.startDate = e.startDate
      this.endDate = e.endDate
      this.downloadReportAllEX()
    },
    filterClear() {
      this._resetGrades()
      this._resetLevels()
      this.size = ''
      this.offset = ''
      this.timeLast = moment().format('YYYY-MM-DD')
      this.search = ''
      this.id_level = ''
      this.id_grade_group = ''
      this.id_web_role = ''
      this.temperatures = []
      this.profiles = []
      this.order_field = ''
      this.order_direction = ''
      this.temperature = []
      this.roles = []
      this.filterby = ''
      this.min_temp = ''
      this.max_temp = ''
      this.min_temp = ''
      this.max_temp = ''
      // this.pagination.sortBy = null
      // this.pagination.descending = null
      this.pagination = {
        ...this.pagination,
        sortBy: 'inAt',
        descending: false,
        rowsPerPage: 25,
      }
      this.showFilters = false
      this.timeFirst = moment().format('YYYY-MM-DD')
      this.getEntries()
    },
    _resetLevels() {
      this.levels = this.posibleFilters.levels
      this.filters.levelIds = ''
    },
    _resetGrades() {
      this.grades = this.posibleFilters.gradeGroups
      this.filters.gradeGroupIds = ''
    },
    async getLevels() {
      if (this.getBranch && this.getBranch.id) {
        try {
          const { data } = await this.$store.dispatch(
            'student/getStudentsFilters',
            this.getBranch.id
          )

          const levels1 = parseLevels({ levels: data })
          const groups1 = parseGroups({ gradeGroups: data })

          this.levels = levels1
          this.grades = groups1
          this.posibleFilters = { gradeGroups: groups1, levels: levels1 }
        } catch (error) {
          console.log(error)
          this.posibleFilters = { gradeGroups: [], levels: [] }
        }
      }
    },
    async filterLevel() {
      if (this.filters.levelIds.length === 0) {
        this._resetGrades()
        this._resetLevels()
        return
      }

      const groups = filterByLevel({
        levelIds: this.filters.levelIds.map((e) => e.levelId),
        posibleGroups: this.posibleFilters.gradeGroups,
      })
      this.grades = groups
    },
    getGroupsByLevel(level) {
      this.grades = []
      this.gradeGroup = ''
      if (level) {
        this.$store
          .dispatch('subgroups/posibleGradeGroups', { idLevel: level.levelId })
          .then((response) => {
            var _this = this
            var gg = response.data
            for (var i = 0; i < gg.length; i++) {
              gg[i].name = gg[i].grade + ' ' + gg[i].group
              _this.grades.push(gg[i])
            }
            this.$forceUpdate()
            this.getEntries()
          })
          .catch((error) => {
            this.grades = []
            console.log(error)
          })
      } else this.getEntries()
    },
    getRoomID(idBranch) {
      return idBranch + '-whole-entries'
    },
    subscribeWs() {
      if (!this.connected && this.getBranch && this.getBranch.id) {
        var room = this.getRoomID(this.getBranch.id)
        console.log('Connecting & subscribing to ', room)
        this.$socket.connect()
        this.$socket.emit('subscribe', room)
        this.connected = true
      } else {
        console.log('No branch yet')
      }
    },
    filterTemp(val) {
      if (!this.loading) {
        this.showFilters = false
        this.getEntries()
      }
    },
  },
  mounted() {
    const tempInitialStateParams = this.callApi(null, false, true)
    this.initialStateParams = tempInitialStateParams

    this.getEntries()
    if (this.levels.length === 0) {
      this.getLevels()
    }
    this.subscribeWs()
  },
  beforeDestroy() {
    var room = this.getRoomID(this.getBranch.id)
    console.log('Unsubscribe from', room)
    this.$socket.emit('unsubscribe', room)
  },
  sockets: {
    connect(evt) {
      console.log(1)
      console.log('Connected', evt)
    },
    disconnect(evt) {
      console.log('Disconnected', evt)
    },
    reconnect() {
      console.log('Reconnected')
      this.subscribeWs()
    },
    message(notification) {
      console.log(structuredClone(notification))
      for (let a = 0; a < this.entries.length / 2; a++) {
        this.entries[a].isNew = false
      }
      //Websocket
      var filterLevelId = (this.level || {}).id
      if (filterLevelId && filterLevelId !== notification.idLevel) {
        return
      }

      var filterGradeGroupId = (this.gradeGroup || {}).id
      if (
        filterGradeGroupId &&
        filterGradeGroupId !== notification.idGradeGroup
      ) {
        return
      }

      if (this.search) {
        var pattern = '^.*' + this.search + '.*'
        var regex = RegExp(pattern, 'i')
        if (
          !regex.test(notification.firstName) &&
          !regex.test(notification.lastName)
        ) {
          return
        }
      }
      //Ajuste de salidas
      if (this.entries) {
        if (notification.outAt) {
          //Salidas
          // this.stats.totalWithExitCount++
          if (notification.revisionIds.length === 0) return

          // console.log(notification.revisionIds)

          // Change the registry entry timeOutAt
          const itemIndex = this.entries.findIndex(
            (e) => e.id === notification.id
          )
          this.entries[itemIndex].outAt = notification.outAt

          // Change all registry revisions timeOutAt
          for (let r = 0; r < notification.revisionIds.length; r++) {
            const itemIndex = this.entries.findIndex(
              (e) => e.id === notification.revisionIds[r]
            )

            this.entries[itemIndex].outAt = notification.outAt
          }
          this.stats.totalWithExitCount++
          // switch (notification.profile) {
          //   case 'Alumno':
          //     if (notification.revisionIds.length > 0) {
          //       console.log(notification.revisionIds)
          //       const itemIndex = this.entries.findIndex(
          //         (e) => e.id === notification.id
          //       )

          //       this.entries[itemIndex].outAt = notification.outAt
          //       for (let r = 0; r < notification.revisionIds.length; r++) {
          //         const itemIndex = this.entries.findIndex(
          //           (e) => e.id === notification.revisionIds[r]
          //         )

          //         this.entries[itemIndex].outAt = notification.outAt
          //       }
          //     }
          //     break
          //   case 'Colaborador':
          //     if (notification.revisionIds.length > 0) {
          //       console.log(notification.revisionIds)
          //       const itemIndex = this.entries.findIndex(
          //         (e) => e.id === notification.id
          //       )

          //       this.entries[itemIndex].outAt = notification.outAt
          //       for (let r = 0; r < notification.revisionIds.length; r++) {
          //         const itemIndex = this.entries.findIndex(
          //           (e) => e.id === notification.revisionIds[r]
          //         )

          //         this.entries[itemIndex].outAt = notification.outAt
          //       }
          //     }
          //     break
          //   case 'Visitante':
          //     if (notification.revisionIds.length > 0) {
          //       console.log(notification.revisionIds)
          //       const itemIndex = this.entries.findIndex(
          //         (e) => e.id === notification.id
          //       )

          //       this.entries[itemIndex].outAt = notification.outAt
          //       for (let r = 0; r < notification.revisionIds.length; r++) {
          //         const itemIndex = this.entries.findIndex(
          //           (e) => e.id === notification.revisionIds[r]
          //         )

          //         this.entries[itemIndex].outAt = notification.outAt
          //       }
          //     }
          //     break
          //   case 'Tutor':
          //     if (notification.revisionIds.length > 0) {
          //       console.log(notification.revisionIds)
          //       const itemIndex = this.entries.findIndex(
          //         (e) => e.id === notification.id
          //       )

          //       this.entries[itemIndex].outAt = notification.outAt
          //       for (let r = 0; r < notification.revisionIds.length; r++) {
          //         const itemIndex = this.entries.findIndex(
          //           (e) => e.id === notification.revisionIds[r]
          //         )

          //         this.entries[itemIndex].outAt = notification.outAt
          //       }
          //     }
          //     break
          //   default:
          //     break
          // }
          // this.totalitemsback--
          // this.$forceUpdate()
        } else {
          if (this.entries.length == 25) {
            this.entries.pop()
          }
          //-- Entradas
          if (notification.assistance == 'Ingreso') {
            console.log(3, notification)
            switch (notification.profile) {
              case 'Alumno':
                this.stats.studentCount++
                this.stats.totalCount++
                if (notification.gender == 'MALE') {
                  this.stats.maleStudentCount++
                }
                if (notification.gender == 'FEMALE') {
                  this.stats.femaleStudentCount++
                }
                break
              case 'Colaborador':
                this.stats.collaboratorCount++
                this.stats.totalCount++
                break
              case 'Visitante':
                this.stats.visitCount++
                this.stats.totalCount++
                break
              case 'Tutor':
                this.stats.parentCount++
                this.stats.totalCount++
                break
              default:
                break
            }
            notification.isNew = true
            this.entries.unshift(notification)
            this.totalitemsback++
            this.$forceUpdate()
          } else {
            notification.isNew = true
            this.entries.unshift(notification)
            this.totalitemsback++
            this.$forceUpdate()
          }
        }
      } else {
        this.entries = [notification]
      }

      var self = this
      setTimeout(function () {
        var item = self.entries.find(function (el) {
          return el.id === notification.id
        })
        if (item) {
          item.isNew = false
        }
      }, 1800)
    },
  },
  watch: {
    getLang() {
      this.setLang()
    },
    getUser() {
      if (this.entries.length <= 0) {
        this.getEntries()
      }

      if (this.levels.length === 0) {
        this.getLevels()
      }
    },
    getBranch() {
      this.subscribeWs()

      if (this.levels.length == 0) {
        this.getLevels()
      }
    },
    timeFirst() {
      this.getEntries()
    },
    timeLast() {
      this.getEntries()
    },
    gradeGroup() {
      this.getEntries()
    },

    pagination: {
      handler() {
        this.getEntries()
      },
    },
    filters: {
      handler() {
        this.getEntries()
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['getUser', 'getBranch', 'getBrandTZ', 'getLang']),
    momentFormatFirst() {
      if (this.timeFirst != null) {
        return moment(this.timeFirst).format('DD/MM/YYYY')
      }
      return ''
    },
    momentFormatLast() {
      if (this.timeLast != null) {
        return moment(this.timeLast).format('DD/MM/YYYY')
      }
      return ''
    },
    showHeaders() {
      return this.headers.filter((s) => this.selectedHeaders.includes(s))
    },
    likesAllFruit() {
      return this.profiles.length === this.perfilAll.length
    },
    likesSomeFruit() {
      return this.profiles.length > 0 && !this.likesAllFruit
    },
    icon() {
      if (this.likesAllFruit) return 'disabled_by_default'
      if (this.likesSomeFruit) return 'indeterminate_check_box'
      return 'check_box_outline_blank'
    },
  },
  created() {
    this.headers = Object.values(this.headersAll)
    this.selectedHeaders = this.headers
  },
}
</script>

<style>
/* .main-tool-bar {
  z-index: 1;
} */
/* .titleSearch .v-input .v-input__slot {
  border-radius: 33px !important;
} */

.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  display: flex !important;
  align-items: center !important;
  min-height: auto !important;
}

.new-entry {
  animation: difuminar 3s 1;
}
.danger {
  background-color: #f5bcc0;
}

@keyframes difuminar {
  0% {
    background-color: rgba(143, 188, 143, 1);
  }
  100% {
    background-color: rgba(143, 188, 143, 0);
  }
}
</style>
<style scoped>
th {
  text-transform: uppercase;
}
.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
}
.icon-select {
  padding: 8px;
}
::v-deep .v-input__prepend-outer {
  margin-right: -1px !important;
}

::v-deep .padded .v-input__slot {
  padding-left: 8px !important;
}

::v-deep .v-datatable.v-table > thead {
  display: table;
  width: 100%;
  table-layout: fixed;
}

table.v-table > thead tr {
  height: 40px;
}

::v-deep .v-datatable.v-table > tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

@media (max-width: 600px) {
  ::v-deep .v-datatable.v-table > thead {
    display: block;
  }
}
</style>
<style scoped>
::v-deep .v-datatable.v-table > thead tr {
  background-color: #dddddd;
  height: 40px;
}
.box-circle-counter > div {
  margin-right: auto;
  margin-left: auto;
}
.box-circle-counter p {
  text-align: center;
  font-weight: 600;
}
</style>
